import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const AboutUs = ({image}) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="max-w-6xl mx-auto py-16 pt-0 px-6 flex flex-col md:flex-row items-center gap-8">
      {/* Image Section */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={visible ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
        transition={{ duration: 0.6 }}
        className="w-full md:w-2/5"
      >
        <img
          src={image}
          alt="Music Promotion"
          className="w-full rounded-lg shadow-lg h-auto min-h-[250px] md:h-[320px] mb-4"
        />
      </motion.div>

      {/* Text Section */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={visible ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="w-full md:w-3/5 text-white text-justify"
      >
        <p className="text-lg text-gray-300 mb-4">
          <span className="text-yellow-400 text-3xl">W</span>e help artists gain exposure by uploading their music to{" "}
          <span className="font-bold">top streaming platforms</span>, ensuring maximum reach. Our system creates a{" "}
          <span className="font-bold">personalized fan page</span> where audiences can explore the{" "}
          <span className="font-bold">artist’s music, bio, and latest updates</span>. Whether you are an independent
          artist or a growing band, our platform is designed to <span className="font-bold">amplify your presence online</span>.
        </p>
        <p className="text-lg text-gray-300 mb-4">
          <span className="text-yellow-400 text-3xl">W</span>ith our cutting-edge technology, your
          <span className="font-bold"> profile and tracks are easily accessible to a broader audience</span>, helping you
          <span className="font-bold"> grow your fanbase</span> and <span className="font-bold">boost streams across multiple channels</span>.
          We also provide <span className="font-bold">in-depth analytics</span> to help you track your growth and engagement levels,
          ensuring that your <span className="font-bold">music reaches the right audience</span> at the right time.
        </p>
        <Link
          to="/about"
          className="inline-block bg-yellow-400 text-gray-900 font-semibold py-2 px-6 rounded-full shadow-md hover:bg-yellow-300 transition duration-300"
        >
          Learn More
        </Link>
      </motion.div>
    </section>
  );
};

export default AboutUs;